import React from 'react';

import { ResponsiveContainer, BarChart, Bar, Legend, XAxis, YAxis, Tooltip, ReferenceLine } from 'recharts';

import Tick from 'components/charts/Tick';
import BusinessChangeTooltip from './BusinessChangeTooltip';

const Chart = ({
    data,
    bars,
    xAxisValueAccessor,
    xAxisTickFormatter,
    yAxisTickFormatter,
    tooltipLabelFormatter,
    tooltipFormatter,
    onClickBar,
    dashboardVersion = false,
}) => {
    const onClickChart = (clickedBar) => {
        if (clickedBar) onClickBar(clickedBar.stayDate);
    };
    const onClickAxis = (clickedAxis) => {
        if (clickedAxis) onClickBar(clickedAxis.value);
    };
    const xAxisTick = (tickProps) => <Tick {...tickProps} formatter={xAxisTickFormatter} />;
    const yAxisTick = (tickProps) => <Tick {...tickProps} formatter={yAxisTickFormatter} />;

    return (
        <ResponsiveContainer height={dashboardVersion ? 220 : 300}>
            <BarChart data={data} stackOffset="sign" barSize={40}>
                <Tooltip
                    cursor={false}
                    content={BusinessChangeTooltip}
                    labelFormatter={tooltipLabelFormatter}
                    formatter={tooltipFormatter}
                    isAnimationActive={false}
                />
                {bars.map((bar) => (
                    <Bar
                        cursor="pointer"
                        key={bar.type}
                        name={bar.label}
                        dataKey={bar.valueAccessor}
                        stackId={bar.stackId}
                        fill={bar.colour}
                        isAnimationActive={false}
                        onClick={onClickChart}
                    />
                ))}
                <ReferenceLine y={0} />
                <XAxis
                    dataKey={xAxisValueAccessor}
                    tickFormatter={xAxisTickFormatter}
                    tick={xAxisTick}
                    tickLine={false}
                    axisLine={false}
                    interval="preserveStartEnd"
                    height={35}
                    tickMargin={10}
                    onClick={onClickAxis}
                />
                <YAxis
                    tickLine={false}
                    allowDecimals={false}
                    tick={yAxisTick}
                    domain={['dataMin', 'dataMax']}
                    width={40}
                />
                <Legend iconType="circle" iconSize={11} />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default Chart;
